import React, {useId} from 'react';
import {observer} from "mobx-react";

type TooltipV1Props = {
    content: string | null
}

const TooltipV1 = observer((props: TooltipV1Props) => {
    const id = useId();

    if(props.content === null)
        return ;

    return (
        <div className="tooltip-v1 js-tooltip" data-pt-title={props.content} data-pt-position="top">
            <svg className="icon-v1 checkbox-v1__tooltip-icon" width="14" height="14">
                <use xlinkHref="/build/sprite.svg?1745931509#info-icon">
                </use>
            </svg>
            <div className="tooltip-templates">
                <div id={id} className="tooltip__container _big">
                    {props.content}
                </div>
            </div>
        </div>
    );

})

export default TooltipV1;